/**
 * Newsletter popup — session dismiss + delay
 */
(function () {
  'use strict';

  var KEY = 'sw_popup_newsletter_dismissed';

  document.addEventListener('DOMContentLoaded', function () {
    var overlay = document.querySelector('[data-sw-popup-overlay]');
    if (!overlay) return;
    if (sessionStorage.getItem(KEY)) return;

    var delay = parseInt(overlay.getAttribute('data-delay-seconds') || '5', 10) * 1000;
    var closeBtn = overlay.querySelector('[data-sw-popup-close]');
    var skip = overlay.querySelector('[data-sw-popup-skip]');

    function close() {
      overlay.hidden = true;
      sessionStorage.setItem(KEY, '1');
      document.body.classList.remove('sw-popup-open');
    }

    setTimeout(function () {
      overlay.hidden = false;
      document.body.classList.add('sw-popup-open');
      var focusEl = overlay.querySelector('input[type="email"], button');
      if (focusEl) focusEl.focus();
    }, delay);

    if (closeBtn) closeBtn.addEventListener('click', close);
    if (skip) skip.addEventListener('click', close);

    overlay.addEventListener('click', function (e) {
      if (e.target === overlay) close();
    });

    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape' && !overlay.hidden) close();
    });
  });
})();
